document.documentElement.classList.remove('no-js');

const money = (cents, format) => {
  const value = Number(cents || 0) / 100;
  if (format && format.includes('{{amount_no_decimals}}')) return Math.round(value).toString();
  return value.toFixed(2);
};

const bumpVisibleCartCount = (quantity) => {
  const counts = Array.from(document.querySelectorAll('.cart-count'));
  const current = counts.reduce((highest, count) => {
    const value = Number.parseInt(count.textContent || '0', 10);
    return Number.isFinite(value) ? Math.max(highest, value) : highest;
  }, 0);
  const next = current + quantity;
  counts.forEach((count) => {
    count.textContent = String(next);
    count.setAttribute('aria-label', `${next} item${next === 1 ? '' : 's'}`);
  });
  document.querySelectorAll('a[href$="/cart"], a[href="/cart"]').forEach((link) => {
    link.setAttribute('aria-label', `Cart with ${next} item${next === 1 ? '' : 's'}`);
  });
};

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-menu-toggle]');
  if (trigger) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!open));
    menu?.toggleAttribute('hidden', open);
    document.body.classList.toggle('menu-open', !open);
  }

  const thumb = event.target.closest('[data-media-target]');
  if (thumb) {
    const target = document.getElementById(thumb.dataset.mediaTarget);
    target?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    document.querySelectorAll('[data-media-target]').forEach((item) => item.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }
});

document.addEventListener('change', (event) => {
  const picker = event.target.closest('[data-variant-picker]');
  if (!picker) return;
  const root = picker.closest('[data-product-root]');
  const variants = JSON.parse(root.querySelector('[data-product-variants]').textContent);
  const options = Array.from(root.querySelectorAll('[data-option-position]')).map((group) => {
    return group.querySelector('input:checked')?.value;
  });
  const variant = variants.find((candidate) => candidate.options.every((option, index) => option === options[index]));
  const input = root.querySelector('[name="id"]');
  const button = root.querySelector('[data-add-button]');
  if (!variant) {
    button.disabled = true;
    button.querySelector('span').textContent = 'Unavailable';
    return;
  }
  input.value = variant.id;
  button.disabled = !variant.available;
  button.querySelector('span').textContent = variant.available ? 'Add to cart' : 'Sold out';
  const price = root.querySelector('[data-product-price]');
  if (price) price.textContent = `${root.dataset.currencySymbol || '$'}${money(variant.price, root.dataset.moneyFormat)}`;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  window.history.replaceState({}, '', url);
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-ajax-product-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[data-add-button]');
  const label = button.querySelector('span');
  const original = label.textContent;
  button.disabled = true;
  label.textContent = 'Adding…';
  try {
    const formData = new FormData(form);
    const parsedQuantity = Number.parseInt(String(formData.get('quantity') || '1'), 10);
    const addedQuantity = Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    });
    if (!response.ok) throw new Error('Unable to add this item.');
    const item = await response.json();
    label.textContent = 'Added ✓';
    const live = document.querySelector('[data-cart-live-region]');
    if (live) live.textContent = `${item.title} added to cart.`;
    bumpVisibleCartCount(addedQuantity);
    setTimeout(() => { label.textContent = original; button.disabled = false; }, 1600);
  } catch (error) {
    label.textContent = error.message;
    setTimeout(() => { label.textContent = original; button.disabled = false; }, 2200);
  }
});
